var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-center align-center"},[_c('v-img',{staticClass:"ma-auto",staticStyle:{"object-fit":"cover"},attrs:{"max-height":"30%","max-width":"30%","src":require("@/assets/coloring_logo.png")}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }